import { render, staticRenderFns } from "./Modal.vue?vue&type=template&id=8527aeda&"
import script from "./Modal.vue?vue&type=script&lang=js&"
export * from "./Modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ccsbetaccscom/web/live/ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8527aeda')) {
      api.createRecord('8527aeda', component.options)
    } else {
      api.reload('8527aeda', component.options)
    }
    module.hot.accept("./Modal.vue?vue&type=template&id=8527aeda&", function () {
      api.rerender('8527aeda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/system-alerts/Modal.vue"
export default component.exports